// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__j4rYD","content":"default_content__VKyZE","column":"default_column__OGyFG"};